import React,{forwardRef, useState, useEffect} from 'react'
import OthersSetupForm from './OthersSetupForm';
import UpdateDrawerInfo from '../../../../../../../../../component/common/UpdateDrawerInfo';

const OthersSetupUpdateDrawer = forwardRef((props, ref) => {
    const {
        formValidateError, 
        othersFormSave, 
        updateOthersData, 
        formData, 
        isFormSubmitted,
        drawerIsOpen
    } = props;

    const [updateInfo, setUpdateInfo] = useState({
        isOpen: '',
        title: '',
        information: ''
    });

    const colmd = updateInfo.isOpen === 'open' ? 'col-md-7' : 'col-md-12'

    useEffect(() => {
        props.isUpdateInfo(updateInfo)
    }, [updateInfo]);

    useEffect(() => {
        if(!drawerIsOpen){
            setUpdateInfo({
                isOpen: 'close',
                title: '',
                information: '',
            })
        }
    },[drawerIsOpen])

    return (
        <>
            <div className='row p-5'>
                <div className={`${colmd}`}>
                    <OthersSetupForm
                        formValidateError={formValidateError}
                        othersFormSave={othersFormSave}
                        updateOthersData={updateOthersData}
                        formActionType={'update'}
                        formData={formData}
                        ref={ref}
                        isFormSubmitted={isFormSubmitted}
                        isRefresh={props.isRefresh}
                        isInfoOpenHandler={(data) => 
                            setUpdateInfo({
                                isOpen: data.type,
                                title: data.data.title,
                                information: data.data.info,
                            })
                        }
                    />
                </div>
                {
                    updateInfo.isOpen === 'open' &&
                    <div className={`col-md-5`}>
                        <UpdateDrawerInfo
                            title={updateInfo.title}
                            information={updateInfo.information}
                            infoCloseOnClick={() => 
                                setUpdateInfo({
                                    isOpen: '',
                                    title: '',
                                    information: '',
                                })
                            }
                        />
                    </div>
                }
            </div>
        </>
    )
})

export default OthersSetupUpdateDrawer